var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseAllCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.352 3.602l-.704-.704L3.5.047l2.852 2.851-.704.704L4 1.953V8h7V1.953L9.352 3.602l-.704-.704L11.5.047l2.852 2.851-.704.704L12 1.953V9H8v7H7V9H3V1.953L1.352 3.602z",
    fill: "currentColor"
  })));
}

export default SvgCloseAllCards;